/**
 * @file
 * Insights listings: chips drive the view's hidden exposed filter.
 *
 * Used by /insights (topic chips, parameter "topic") and by the Our Thinking
 * hub's listing (pillar pills, parameter "pillar"); the chips nav names its
 * parameter in data-k-ins-param.
 *
 * The chips are ordinary links to ?topic=… / ?pillar=… and work as such.
 * With JavaScript, a click copies the value into the exposed form and
 * presses its submit button, which Views' own AJAX handling (ajax_view.js)
 * turns into an in-place refresh of the whole view - chips, cards and
 * pager. The address bar is updated so the filtered view stays shareable,
 * and Back/Forward replay the filter.
 */
(function (Drupal, once) {
  'use strict';

  const CHIP = '[data-k-ins-topic]';

  // The value whose chip was pressed, so focus can return to it once Views
  // has swapped the whole view element out (nothing on the old element
  // survives the swap).
  let pendingFocus = null;

  /**
   * The exposed-filter parameter a listing section uses.
   */
  function paramFor(section) {
    const nav = section.querySelector('[data-k-ins-param]');
    return (nav && nav.dataset.kInsParam) || 'topic';
  }

  /**
   * Submits the exposed form for a value. Returns false when it can't.
   */
  function applyTopic(view, param, topic) {
    const form = view.querySelector('form.views-exposed-form');
    const input = form && form.querySelector('[name="' + param + '"]');
    const submit = form && form.querySelector('[type="submit"]');
    if (!input || !submit) {
      return false;
    }
    input.value = topic;
    // Views binds its AJAX submit to the button's click.
    submit.click();
    return true;
  }

  Drupal.behaviors.keidoInsightsFilter = {
    attach(context) {
      once('k-ins-filter', '.k-ins', context).forEach((section) => {
        const view = section.closest('[class*="js-view-dom-id-"]');
        if (!view) {
          return;
        }
        const param = paramFor(section);

        section.addEventListener('click', (event) => {
          const chip = event.target.closest(CHIP);
          if (!chip || event.defaultPrevented || event.button !== 0
            || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
          }
          if (applyTopic(view, param, chip.dataset.kInsTopic || '')) {
            event.preventDefault();
            window.history.pushState({ kInsTopic: chip.dataset.kInsTopic || '', kInsParam: param }, '', chip.getAttribute('href'));
            // Keyboard users land back on the control they used once the
            // view has been swapped out.
            pendingFocus = chip.dataset.kInsTopic || '';
          }
        });
      });

      // After an AJAX refresh the view arrives as new context: announce the
      // result count and restore focus to the chip that was pressed.
      once('k-ins-status', '[data-k-ins-status]', context).forEach((status) => {
        if (context === document) {
          return;
        }
        Drupal.announce(status.textContent.trim());
        const view = status.closest('[class*="js-view-dom-id-"]');
        if (!view || pendingFocus === null) {
          return;
        }
        const wanted = pendingFocus;
        pendingFocus = null;
        const chip = Array.from(view.querySelectorAll('.k-ins__chip'))
          .find((el) => (el.dataset.kInsTopic || '') === wanted);
        if (chip) {
          chip.focus({ preventScroll: true });
        }
      });
    },
  };

  window.addEventListener('popstate', () => {
    document.querySelectorAll('.k-ins').forEach((section) => {
      const view = section.closest('[class*="js-view-dom-id-"]');
      if (!view) {
        return;
      }
      const param = paramFor(section);
      const topic = new URLSearchParams(window.location.search).get(param) || '';
      if (!applyTopic(view, param, topic)) {
        window.location.reload();
      }
    });
  });
})(Drupal, once);
